import React from "react"
import { navigate, withPrefix } from "gatsby"
import { isLoggedIn, getUser } from "../../helpers/loginHelper"

const PrivateRoute = ({ component: Component, location }) => {
    // if the user is not loggedin, navigate back to login page
    if ((!isLoggedIn() && location.pathname !== `${withPrefix("/partners/login")}`) || `${withPrefix("/partners/") + getUser().path}` !== location.pathname ) {
      console.log("Not LoggedIn...");
      navigate("/partners/login");
      return null;
    }

    return <Component />;
}

export default PrivateRoute
